import React from 'react';
import { X } from 'lucide-react';

export default function Chips({ items, onClearAll }) {
  if (!items?.length) return null;
  return (
    <div className="selection-chips-container">
      <div className="selection-chips">
        {items.map(({ key, label, onRemove }) => (
          <div key={key} className="chip">
            <span className="chip-content">{label}</span>
            <button onClick={onRemove} className="remove-chip-btn" title="Remove">
              <X className="remove-icon" />
            </button>
          </div>
        ))}

        <button onClick={onClearAll} className="clear-all-btn" title="Clear all selections">
          <X className="clear-all-icon" />
          Clear All
        </button>
      </div>
    </div>
  );
}